import React from "react";
import { Phone, MessageSquare, Settings2, UserCog } from "lucide-react";
import { MiniCallFlow } from "./mini-call-flow";

const STEPS = [
  {
    icon: <MessageSquare size={20} className="dark:text-white text-black"/>,
    title: "Connect Numbers",
    description: "Add your WhatsApp and business phone numbers",
  },
  {
    icon: <Settings2 size={20} className="dark:text-white text-black"/>,
    title: "Configure Call Types",
    description: "Choose call types, settings and business hours",
  },
  {
    icon: <UserCog size={20} className="dark:text-white text-black"/>,
    title: "Assign Agents",
    description: "Assign agents and set their availability",
  },
  {
    icon: <Phone size={20} className="dark:text-white text-black"/>,
    title: "Start Handling Calls",
    description: "Go live and begin handling inbound and outbound calls.",
  },
];

// The "Call Management" hero/setup guide at the top of /calls — 4 setup
// steps + an animated flow diagram (hidden below xl, same convention as the
// CDP Unify hero's diagram) + a "Setup Calls" CTA.
export const SetupGuide: React.FC<{ onSetupCalls: () => void }> = ({ onSetupCalls }) => (
  <section className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-5 sm:p-6 shadow-sm">
    <div className="flex flex-col xl:flex-row xl:items-center gap-6 xl:gap-10">
      <div className="flex-1 min-w-0">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {STEPS.map((step) => (
            <div key={step.title} className="min-w-0">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-indigo-50 dark:bg-indigo-500/15 mb-3">
                {step.icon}
              </span>
              <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">{step.title}</h3>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={onSetupCalls}
          className="mt-6 px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg transition-colors shadow-sm"
        >
          Setup Calls
        </button>
      </div>

      <div className="hidden xl:block shrink-0">
        <MiniCallFlow />
      </div>
    </div>
  </section>
);

export default SetupGuide;
